import {mixins} from "../app/mixin";

mixins.push({
    el: '.whyUsStepper',
    data() {
        return {
            selectedCard: 0,
        }
    },
    methods: {
        selectCard(index) {
            if (index !== this.selectedCard) {
                this.selectedCard = index;
            }
        },
    },
});